var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component)?_c(_vm.component,{tag:"component",attrs:{"size":_vm.size,"fill":_vm.fill,"autoMargin":_vm.autoMargin}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }